import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-edit",
  "use": "svg_i-edit-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"svg_i-edit\"><path d=\"M10.325 2.455a1.57 1.57 0 0 1 2.22 2.22l-7.493 7.492L2 13l.832-3.053 7.493-7.492Z\" stroke=\"#20BEE8\" stroke-width=\"2.422\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol